"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Geometry_1 = __importDefault(require("./Geometry"));
var GeometryType_1 = require("./GeometryType");
var GeometryCollectionBase_1 = __importDefault(require("./GeometryCollectionBase"));
var GeometryFactory_1 = __importDefault(require("./GeometryFactory"));
/**
 * @category geom
 * @class
 * @description This class represents the GeometryCollection geometry.
 */
var GeometryCollection = /** @class */ (function (_super) {
    __extends(GeometryCollection, _super);
    function GeometryCollection(geometries) {
        return _super.call(this, geometries) || this;
    }
    Object.defineProperty(GeometryCollection.prototype, "type", {
        get: function () {
            return GeometryType_1.GeometryType.GeometryCollection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryCollection.prototype, "geometries", {
        get: function () {
            return this._geometries;
        },
        enumerable: true,
        configurable: true
    });
    GeometryCollection.prototype.toJSON = function () {
        return {
            type: this.type,
            geometries: this._geometries.map(function (g) { return g.toJSON(); })
        };
    };
    GeometryCollection.prototype._ts = function () {
        return Geometry_1.default._factory.createGeometryCollection(this.children.map(function (l) { return l._ts(); }));
    };
    GeometryCollection.prototype._clone = function (convert) {
        return new GeometryCollection(this._cloneChildren(convert));
    };
    GeometryCollection._from = function (geometryCollection) {
        var geom = new GeometryCollection();
        var count = geometryCollection.getNumGeometries();
        for (var i = 0; i < count; i++) {
            geom.children.push(GeometryFactory_1.default.create(geometryCollection.getGeometryN(i)));
        }
        return geom;
    };
    return GeometryCollection;
}(GeometryCollectionBase_1.default));
exports.default = GeometryCollection;
